/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

/**
 * MyIssues page view (component).
 *
 * @author jgeorgiadou@frontier.co.uk
 */

import {Component, Vue} from 'vue-property-decorator';
import IssuesList from '@/components/IssuesList/scripts';
import {Action, Getter} from 'vuex-class';
import {UserDetailsInterface} from '@/store/modules/user-session/types';

const namespace: string = 'userSessionModule';

@Component({
    name: 'v-my-issues',
    components: {
        'c-issues-list': IssuesList,
    },
})

export default class MyIssues extends Vue {
    // User Details
    @Getter('getUserDetails', {namespace})
    public getUserDetails!: UserDetailsInterface;

    // Page Title
    @Action('updatePageTitle', {namespace: 'settingsModule'})
    public updatePageTitle!: (title: string) => void;

    // Update current view name in state
    @Action('updateCurrentView', {namespace: 'userSessionModule'})
    public updateCurrentView!: (view: {name: string, params?: any} | undefined) => void;

    public stateName: string = '';
    public bntStyleCreated: string =  'my-issue-title-on-click';
    public bntStyleVoted: string = 'my-issue-title';
    public bntStyleContributed: string = 'my-issue-title';

    // Issue filters based on state
    public filters: { itemsPerPage: number; customerId?: string | undefined } = {
        itemsPerPage: 10,
    };

    /**
     * Mounted life-cycle event.
     *
     * Initialises the loader.
     */
    public async mounted(): Promise<void> {
        // Set the page title
        this.updatePageTitle(this.$i18n.translate('menu.header.myIssues', {}) || '');

        // Update current view name in state
        this.updateCurrentView({name: this.$router.currentRoute.name || 'home'});
        this.stateName = 'my';

        this.updateStateFilters();
    }

    /**
     * Change the title style when on click
     * @param menu
     */
    public onClick(menu: string): void {
        if (menu === 'created') {
            this.bntStyleCreated = 'my-issue-title-on-click';
            this.bntStyleVoted = 'my-issue-title';
            this.bntStyleContributed = 'my-issue-title';
        }

        if (menu === 'voted') {
            this.bntStyleVoted = 'my-issue-title-on-click';
            this.bntStyleCreated = 'my-issue-title';
            this.bntStyleContributed = 'my-issue-title';
        }

        if (menu === 'contributed') {
            this.bntStyleContributed = 'my-issue-title-on-click';
            this.bntStyleVoted = 'my-issue-title';
            this.bntStyleCreated = 'my-issue-title';
        }

        this.updateStateFilters();
    }

    /**
     * Change issue filters based on state.
     */
    public updateStateFilters(): void {
        if (this.stateName === 'my-contribute') {
            delete this.filters.customerId;

            return;
        }

        this.filters.customerId = this.getUserDetails.userId;
    }
}
